(() => {
  const root = document.querySelector('[data-cs-porch]');
  if (!root || root.dataset.csPorchReady === 'true') return;
  root.dataset.csPorchReady = 'true';

  const configEl = root.querySelector('[data-cs-porch-config]');
  let config = {};

  try {
    config = JSON.parse(configEl?.textContent || '{}');
  } catch (error) {
    console.error('Cold Sugar porch configuration could not be read.', error);
    return;
  }

  const hero = root.querySelector('.cs-porch__hero');
  const statusCard = root.querySelector('[data-cs-porch-status-card]');
  const statusLabel = root.querySelector('[data-cs-porch-status-label]');
  const statusTitle = root.querySelector('[data-cs-porch-status-title]');
  const statusCopy = root.querySelector('[data-cs-porch-status-copy]');
  const countdown = root.querySelector('[data-cs-porch-countdown]');
  const countdownParts = {
    days: root.querySelector('[data-countdown-days]'),
    hours: root.querySelector('[data-countdown-hours]'),
    minutes: root.querySelector('[data-countdown-minutes]'),
    seconds: root.querySelector('[data-countdown-seconds]'),
  };
  const operatorPanel = root.querySelector('[data-cs-porch-operator]');
  const operatorCode = root.querySelector('[data-cs-porch-operator-code]');
  const methodPicker = root.querySelector('[data-cs-porch-method-picker]');
  const methodButtons = Array.from(root.querySelectorAll('[data-cs-porch-method]'));
  const accessPanel = root.querySelector('[data-cs-porch-access]');
  const accessForm = root.querySelector('[data-cs-porch-access-form]');
  const accessInput = root.querySelector('[data-cs-porch-code-input]');
  const accessMessage = root.querySelector('[data-cs-porch-access-message]');
  const tracker = root.querySelector('[data-cs-porch-tracker]');
  const trackerViewport = root.querySelector('[data-cs-porch-tracker-viewport]');
  const trackerCopy = root.querySelector('[data-cs-porch-tracker-copy]');
  const trackerProgress = root.querySelector('[data-cs-porch-tracker-progress]');
  const trackerSteps = Array.from(
    root.querySelectorAll('[data-cs-porch-tracker-step]')
  );

  const trackerMobileMedia =
    window.matchMedia('(max-width: 749px)');

  const reducedMotionMedia =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const trackerHome =
    tracker
      ? document.createComment(
          'Cold Sugar Porch tracker home'
        )
      : null;

  let floatingTracker = null;
  let floatingTrackerProgress = null;
  let floatingTrackerSteps = [];

  if (tracker && trackerHome) {
    tracker.before(trackerHome);

    const floatingCanvas =
      tracker
        .querySelector(
          '.cs-porch__tracker-canvas'
        )
        ?.cloneNode(true);

    if (floatingCanvas) {
      floatingCanvas.className =
        'cs-porch__tracker-float-canvas';

      const floatingList =
        floatingCanvas.querySelector(
          '.cs-porch__tracker-list'
        );

      if (floatingList) {
        floatingList.className =
          'cs-porch__tracker-float-list';
      }

      floatingCanvas
        .querySelectorAll(
          '.cs-porch__tracker-label'
        )
        .forEach(
          (label) => label.remove()
        );

      floatingTracker =
        document.createElement('div');

      floatingTracker.className =
        'cs-porch__tracker-float';

      floatingTracker.setAttribute(
        'aria-hidden',
        'true'
      );

      floatingTracker.append(
        floatingCanvas
      );

      root.append(
        floatingTracker
      );

      floatingTrackerProgress =
        floatingTracker.querySelector(
          '[data-cs-porch-tracker-progress]'
        );

      floatingTrackerSteps =
        Array.from(
          floatingTracker.querySelectorAll(
            '[data-cs-porch-tracker-step]'
          )
        );
    }
  }

  const menuKicker = root.querySelector('[data-cs-porch-menu-kicker]');
  const menuTitle = root.querySelector('[data-cs-porch-menu-title]');
  const menuCopy = root.querySelector('[data-cs-porch-menu-copy]');
  const notice = root.querySelector('[data-cs-porch-notice]');
  const productList = root.querySelector('[data-cs-porch-products]');
  const productCards = Array.from(root.querySelectorAll('[data-cs-porch-product]'));
  const switchDialog = root.querySelector('[data-cs-porch-switch-dialog]');
  const switchDialogClose = root.querySelector('[data-cs-porch-dialog-close]');
  const switchDialogKeep = root.querySelector('[data-cs-porch-dialog-keep]');
  const switchDialogSwitch = root.querySelector('[data-cs-porch-dialog-switch]');
  const productDialog = root.querySelector('[data-cs-porch-product-dialog]');
  const productDialogClose = root.querySelector('[data-cs-porch-product-dialog-close]');
  const productDialogContent = root.querySelector('[data-cs-porch-product-dialog-content]');
  const switchDialogKicker = switchDialog?.querySelector('.cs-porch__section-kicker');
  const switchDialogTitle = switchDialog?.querySelector('h2');
  const switchDialogMessage =
    switchDialog?.querySelector('.cs-porch__dialog-copy') ||
    switchDialog?.querySelector('h2 + p');
  const switchDialogActions =
    switchDialog?.querySelector('.cs-porch__dialog-actions');

  let switchDialogItems =
    switchDialog?.querySelector('[data-cs-porch-dialog-items]');

  if (switchDialog && switchDialogActions && !switchDialogItems) {
    switchDialogItems = document.createElement('ul');
    switchDialogItems.className = 'cs-porch__dialog-items';
    switchDialogItems.dataset.csPorchDialogItems = '';
    switchDialogItems.hidden = true;
    switchDialogActions.before(switchDialogItems);
  }
  const detailsKicker = root.querySelector('#PorchDetails .cs-porch__section-kicker');
  const detailCards = Array.from(root.querySelectorAll('.cs-porch__details-grid article'));
  const pickupDetailDefaults = detailCards.map((card) => ({
    heading: card.querySelector('h3')?.textContent.trim() || '',
    paragraphs: Array.from(card.querySelectorAll('p')).map((node) => node.textContent.trim()),
  }));

  let lastProductDialogTrigger = null;
  let activeProductDialogCard = null;
  let productDialogObserver = null;
  let selectedMethod = 'pickup';
  let currentSchedule = null;
  let currentState = 'closed';
  let liveAccessGranted = false;
  let pendingAdd = null;
  let pendingMigration = null;
  let inventoryByGid = new Map();
  let inventoryLoading = false;
  let countdownTimer = null;
  let stateTimer = null;
  let inventoryTimer = null;

  const STALE_ATTRIBUTES = [
    'Fulfillment Category', 'Fulfillment Type', 'Fulfillment Option Handle',
    'Fulfillment Option Name', 'Pickup Event ID', 'Pickup Date', 'Pickup Day',
    'Pickup Location', 'Pickup City State', 'Pickup Address', 'Pickup Window',
    'Pickup Instructions', 'Delivery Event ID', 'Delivery Date', 'Delivery Day',
    'Delivery Area', 'Delivery Window', 'Delivery Zip Code', 'Delivery Instructions',
    'Shipping Event ID', 'Shipping Option', 'Requested Delivery Date',
    'Requested Delivery Day', 'Estimated Ship Date', 'Shipping Method',
    'Checkout Method To Select', 'Shopping Path', 'Porch Live Purchase',
    'Thursday Preorder Close Time', 'Thursday Live Open Time', 'Thursday Live Close Time'
  ];

  function normalizeBoolean(value) {
    return value === true || String(value || '').toLowerCase() === 'true';
  }

  function isMenuReady() {
    // The weekly Porch menu is ready as soon as at least one
    // product exists in the current Porch Shop collection.
    return productCards.length > 0;
  }

  function normalizeList(value) {
    if (Array.isArray(value)) return value.map(String).map((item) => item.trim()).filter(Boolean);
    return String(value || '').split(/\r?\n|,/).map((item) => item.trim()).filter(Boolean);
  }

  function parseWeekdays(value) {
    const map = {
      sunday: 0, sun: 0,
      monday: 1, mon: 1,
      tuesday: 2, tue: 2,
      wednesday: 3, wed: 3,
      thursday: 4, thu: 4,
      friday: 5, fri: 5,
      saturday: 6, sat: 6,
    };

    return normalizeList(value)
      .map((item) => map[item.toLowerCase().replace(/s$/, '')])
      .filter((item) => Number.isInteger(item));
  }

  function getZonedNow() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: config.timeZone || 'America/Chicago',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());

    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return new Date(Date.UTC(
      values.year,
      values.month - 1,
      values.day,
      values.hour,
      values.minute,
      values.second
    ));
  }

  function dateFromISO(value) {
    const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  }

  function toISODate(date) {
    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0'),
    ].join('-');
  }

  function addDays(date, days) {
    const next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + days);
    return next;
  }

  function atTime(date, value) {
    const [hours, minutes] = String(value || '00:00').split(':').map(Number);
    return new Date(Date.UTC(
      date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
      Number.isFinite(hours) ? hours : 0,
      Number.isFinite(minutes) ? minutes : 0,
      0
    ));
  }

  function formatDate(date, includeYear = false) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'long', month: 'long', day: 'numeric',
      ...(includeYear ? { year: 'numeric' } : {}),
    }).format(date);
  }

  function formatDay(date) {
    return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long' }).format(date);
  }

  function isDateAllowed(date) {
    const weekdays = parseWeekdays(config.porch?.activeWeekdays || 'thursday');
    const start = dateFromISO(config.porch?.startDate);
    const end = dateFromISO(config.porch?.endDate);

    if (weekdays.length && !weekdays.includes(date.getUTCDay())) return false;
    if (start && date < start) return false;
    if (end && date > end) return false;
    return true;
  }

  function findNextEventDate(startDate, includeStart = true) {
    const override = dateFromISO(config.porch?.eventDateOverride);
    if (override && override >= startDate) return override;

    for (let offset = includeStart ? 0 : 1; offset <= 42; offset += 1) {
      const candidate = addDays(startDate, offset);
      if (isDateAllowed(candidate)) return candidate;
    }

    return addDays(startDate, 7);
  }

  function buildSchedule(now = getZonedNow()) {
    const today = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate()
      )
    );

    let eventDate =
      findNextEventDate(today, true);

    const times = {
      liveOpen:
        config.porch?.liveOpenTimeOverride ||
        config.liveOpenTime ||
        '15:00',
      closingSoon:
        config.porch?.closingSoonTimeOverride ||
        config.closingSoonTime ||
        '18:15',
      liveClose:
        config.porch?.liveCloseTimeOverride ||
        config.liveCloseTime ||
        '19:00',
      reset:
        config.porch?.resetTimeOverride ||
        config.resetTime ||
        '22:00',
    };

    let resetAt =
      atTime(
        eventDate,
        times.reset
      );

    if (now >= resetAt) {
      eventDate =
        findNextEventDate(
          addDays(eventDate, 1),
          true
        );

      resetAt =
        atTime(
          eventDate,
          times.reset
        );
    }

    const previewAt =
      atTime(
        addDays(
          eventDate,
          -Number(
            config.previewDaysBefore ||
            3
          )
        ),
        '00:00'
      );

    const eventDayStart =
      atTime(
        eventDate,
        '00:00'
      );

    const liveOpenAt =
      atTime(
        eventDate,
        times.liveOpen
      );

    const closingSoonAt =
      atTime(
        eventDate,
        times.closingSoon
      );

    const liveCloseAt =
      atTime(
        eventDate,
        times.liveClose
      );

    return {
      now,
      eventDate,
      previewAt,
      eventDayStart,
      liveOpenAt,
      closingSoonAt,
      liveCloseAt,
      resetAt,
      times,
      iso: toISODate(eventDate),
    };
  }

  function resolveState(schedule) {
    const previewParams = new URLSearchParams(window.location.search);
    const configuredForced = String(
      config.previewState || root.dataset.previewState || 'auto'
    ).trim().toLowerCase();

    const requestedForced = String(
      previewParams.get('preview_state') || ''
    ).trim().toLowerCase();

    const allowedPreviewStates = [
      'auto',
      'closed',
      'preview',
      'countdown',
      'live',
      'live_closing',
      'ended',
      'cancelled',
    ];

    const forced =
      allowedPreviewStates.includes(
        requestedForced
      )
        ? requestedForced
        : allowedPreviewStates.includes(
            configuredForced
          )
          ? configuredForced
          : 'auto';

    const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
    const isThemePreview = Boolean(
      window.Shopify?.designMode ||
      themeRole === 'unpublished' ||
      themeRole === 'development' ||
      ['127.0.0.1', 'localhost'].includes(window.location.hostname)
    );

    // Forced states are honored only in the theme editor or an unpublished-theme
    // preview. A published storefront always follows the real event schedule.
    if (forced && forced !== 'auto' && isThemePreview) return forced;

    const blockedCancellationApplies =
      normalizeList(config.porch?.blockedDates).includes(schedule.iso);

    const cancellationDate = dateFromISO(config.porch?.eventCancelledDate);
    const cancellationApplies = normalizeBoolean(config.porch?.eventCancelled) &&
      (!cancellationDate || toISODate(cancellationDate) === schedule.iso);

    if (blockedCancellationApplies || cancellationApplies) return 'cancelled';

    const now = schedule.now;

    if (now < schedule.previewAt) {
      return 'closed';
    }

    if (now < schedule.eventDayStart) {
      return 'preview';
    }

    if (now < schedule.liveOpenAt) {
      return 'countdown';
    }

    if (now < schedule.closingSoonAt) {
      return 'live';
    }

    if (now < schedule.liveCloseAt) {
      return 'live_closing';
    }

    return 'ended';
  }


  function syncLocalPreviewContext() {
    const previewParams =
      new URLSearchParams(
        window.location.search
      );

    const requestedState =
      String(
        previewParams.get(
          'preview_state'
        ) || ''
      )
        .trim()
        .toLowerCase();

    const configuredState =
      String(
        config.previewState ||
        root.dataset.previewState ||
        'auto'
      )
        .trim()
        .toLowerCase();

    const forcedState =
      requestedState ||
      (
        configuredState !== 'auto'
          ? configuredState
          : ''
      );

    const themeRole =
      String(
        window.Shopify?.theme?.role ||
        ''
      ).toLowerCase();

    const isThemePreview =
      Boolean(
        window.Shopify?.designMode ||
        themeRole ===
          'unpublished' ||
        themeRole ===
          'development' ||
        [
          '127.0.0.1',
          'localhost',
        ].includes(
          window.location.hostname
        )
      );

    if (
      !isThemePreview ||
      !forcedState
    ) {
      try {
        sessionStorage.removeItem(
          'coldSugarPorchPreviewContext'
        );
      } catch (error) {
        // Session storage is optional.
      }

      return;
    }

    try {
      sessionStorage.setItem(
        'coldSugarPorchPreviewContext',
        JSON.stringify({
          state:
            currentState,
          eventISO:
            currentSchedule?.iso ||
            '',
          savedAt:
            Date.now(),
        })
      );
    } catch (error) {
      // Session storage is optional.
    }
  }

  function generateAccessCode(eventISO) {
    const override = String(config.porch?.accessCodeOverride || config.manualAccessCode || '').trim();
    if (override) return override;

    const input = `${eventISO}|${config.accessSeed || 'cold-sugar-porch'}`;
    let hash = 2166136261;
    for (let index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return String(100000 + (Math.abs(hash >>> 0) % 900000));
  }

  function accessStorageKey() {
    return `coldSugarPorchAccess:${currentSchedule?.iso || ''}`;
  }

  function readLiveAccess() {
    try {
      const raw = sessionStorage.getItem(accessStorageKey());
      const stored = raw ? JSON.parse(raw) : null;
      return Boolean(
        stored &&
        stored.event === currentSchedule.iso &&
        Number(stored.expiresAt) > Date.now()
      );
    } catch (error) {
      return false;
    }
  }

  function saveLiveAccess() {
    try {
      const remainingMs = Math.max(0, currentSchedule.liveCloseAt.getTime() - currentSchedule.now.getTime());
      sessionStorage.setItem(accessStorageKey(), JSON.stringify({
        event: currentSchedule.iso,
        expiresAt: Date.now() + remainingMs,
      }));
    } catch (error) {
      console.warn('Porch access could not be stored for this session.', error);
    }
  }

  function isPreorderState() {
    return false;
  }

  function isLiveState() {
    return ['live', 'live_closing'].includes(currentState);
  }

  function getShoppingPathForMethod() {
    return 'porch_live';
  }

  function getActiveShoppingPath() {
    return getShoppingPathForMethod(selectedMethod);
  }

  function getOptionForMethod() {
    return config.porch;
  }

  function getActiveOption() {
    return getOptionForMethod(selectedMethod);
  }

  function getStateContent(state) {
    const date =
      formatDate(
        currentSchedule.eventDate
      );

    const shortDate =
      date.replace(/^[^,]+,\s*/, '');

    const open =
      formatClock(
        currentSchedule.times.liveOpen
      );

    const close =
      formatClock(
        currentSchedule.times.liveClose
      );

    const content = {
      closed: {
        tone: 'closed',
        label: 'Closed',
        title: 'See you next Thursday',
        copy: 'Planning starts again Monday.',
        menuTitle: '',
        menuCopy: '',
        target: null,
      },

      preview: {
        tone: 'preview',
        label: 'Next shop',
        title: shortDate,
        copy: 'Menu is ready to browse.',
        menuTitle: 'Porch Shop menu',
        menuCopy: '',
        target: currentSchedule.liveOpenAt,
      },

      countdown: {
        tone: 'countdown',
        label: 'Opens today',
        title: open,
        copy: 'Shopping begins soon.',
        menuTitle: 'Porch Shop menu',
        menuCopy: '',
        target: currentSchedule.liveOpenAt,
      },

      live: {
        tone: 'live',
        label: 'Open now',
        title: 'Shop the porch',
        copy: `Open until ${close}.`,
        menuTitle: 'Available now',
        menuCopy: '',
        target: currentSchedule.liveCloseAt,
      },

      live_closing: {
        tone: 'warning',
        label: 'Closing soon',
        title: `Closes at ${close}`,
        copy: 'Shop what’s still on the porch.',
        menuTitle: 'Available now',
        menuCopy: '',
        target: currentSchedule.liveCloseAt,
      },

      ended: {
        tone: 'closed',
        label: 'Closed',
        title: 'See you next Thursday',
        copy: 'Thanks for stopping by.',
        menuTitle: '',
        menuCopy: '',
        target: null,
      },

      cancelled: {
        tone: 'cancelled',
        label: 'Cancelled this week',
        title: shortDate,
        copy:
          config.porch?.scheduleNote ||
          'No Porch Shop this Thursday.',
        menuTitle: '',
        menuCopy: '',
        target: null,
      },
    };

    return (
      content[state] ||
      content.closed
    );
  }

  function formatClock(value) {
    const [hours, minutes] = String(value || '00:00').split(':').map(Number);
    const date = new Date(Date.UTC(2020, 0, 1, hours || 0, minutes || 0));
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', hour: 'numeric', minute: minutes ? '2-digit' : undefined,
    }).format(date);
  }

  function setDetailCard(index, heading, paragraphs) {
    const card = detailCards[index];
    if (!card) return;

    const headingNode = card.querySelector('h3');
    const paragraphNodes = Array.from(card.querySelectorAll('p'));

    if (headingNode) headingNode.textContent = heading;

    paragraphNodes.forEach((node, paragraphIndex) => {
      const copy = paragraphs[paragraphIndex] || '';
      node.textContent = copy;
      node.hidden = !copy;
    });
  }

  function renderMethodDetails() {
    if (detailsKicker) {
      detailsKicker.textContent =
        'Thursday Porch Shop';
    }

    pickupDetailDefaults.forEach(
      (details, index) => {
        setDetailCard(
          index,
          details.heading,
          details.paragraphs
        );
      }
    );
  }

  const TRACKER_STAGES = [
    'planning',
    'mixing',
    'baking',
    'setting',
    'ready',
    'closed',
  ];

  const TRACKER_COPY = {
    planning:
      'We’re choosing this week’s Porch Shop lineup.',
    mixing:
      'The dough is mixing and this week’s bake is underway.',
    baking:
      'The ovens are on and Thursday’s bread is baking.',
    setting:
      'We’re packing the porch and getting everything ready.',
    ready:
      'The porch is stocked and ready to shop.',
    closed:
      'This week’s Porch Shop is closed. Planning starts again Monday.',
  };

  let trackerHasAnimated = false;
  let trackerRenderedStage = '';
  let trackerIsVisible = false;
  let trackerPositionFrame = null;
  let trackerPulseTimer = null;

  function getPreviewTrackerStage() {
    const params =
      new URLSearchParams(
        window.location.search
      );

    const requestedStage =
      String(
        params.get(
          'preview_tracker_state'
        ) || ''
      ).toLowerCase();

    const themeRole =
      String(
        window.Shopify?.theme?.role ||
        ''
      ).toLowerCase();

    const isThemePreview =
      Boolean(
        window.Shopify?.designMode ||
        [
          'unpublished',
          'development',
        ].includes(
          themeRole
        ) ||
        [
          '127.0.0.1',
          'localhost',
        ].includes(
          window.location.hostname
        )
      );

    if (
      isThemePreview &&
      TRACKER_STAGES.includes(
        requestedStage
      )
    ) {
      return requestedStage;
    }

    return '';
  }

  function getTrackerStage() {
    const previewStage =
      getPreviewTrackerStage();

    if (previewStage) {
      return previewStage;
    }

    if (['live', 'live_closing'].includes(currentState)) {
      return 'ready';
    }

    if (['ended', 'cancelled'].includes(currentState)) {
      return 'closed';
    }

    const now =
      currentSchedule?.now ||
      getZonedNow();

    const weekday =
      now.getUTCDay();

    const minutes =
      now.getUTCHours() * 60 +
      now.getUTCMinutes();

    // Monday and Tuesday
    if (weekday === 1 || weekday === 2) {
      return 'planning';
    }

    // Wednesday through Thursday at 6 AM
    if (weekday === 3) {
      return 'mixing';
    }

    if (weekday === 4) {
      if (minutes < 6 * 60) {
        return 'mixing';
      }

      if (minutes < 13 * 60) {
        return 'baking';
      }

      if (minutes < 15 * 60) {
        return 'setting';
      }

      if (minutes < 19 * 60) {
        return 'ready';
      }

      return 'closed';
    }

    // Thursday after 7 PM through Sunday
    return 'closed';
  }

  function centerTrackerStep(step) {
    if (!trackerViewport || !step) return;

    const targetLeft =
      step.offsetLeft -
      (
        trackerViewport.clientWidth -
        step.offsetWidth
      ) / 2;

    trackerViewport.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'auto',
    });
  }

  function applyTrackerState(
    steps,
    progress,
    currentIndex
  ) {
    steps.forEach(
      (step, index) => {
        const isComplete =
          index < currentIndex;

        const isCurrent =
          index === currentIndex;

        step.classList.toggle(
          'is-complete',
          isComplete
        );

        step.classList.toggle(
          'is-current',
          isCurrent
        );

        if (isCurrent) {
          step.setAttribute(
            'aria-current',
            'step'
          );
        } else {
          step.removeAttribute(
            'aria-current'
          );
        }
      }
    );

    if (progress) {
      progress.style.width =
        `${
          (
            currentIndex /
            (
              TRACKER_STAGES.length -
              1
            )
          ) * 100
        }%`;
    }
  }

  function renderTracker() {
    if (
      !tracker ||
      !trackerSteps.length
    ) {
      return;
    }

    const stage =
      getTrackerStage();

    const currentIndex =
      Math.max(
        0,
        TRACKER_STAGES.indexOf(
          stage
        )
      );

    tracker.dataset.currentStage =
      stage;

    applyTrackerState(
      trackerSteps,
      trackerProgress,
      currentIndex
    );

    if (floatingTracker) {
      floatingTracker.dataset.currentStage =
        stage;

      applyTrackerState(
        floatingTrackerSteps,
        floatingTrackerProgress,
        currentIndex
      );
    }

    if (trackerCopy) {
      trackerCopy.textContent =
        TRACKER_COPY[stage] ||
        TRACKER_COPY.planning;
    }

    const stageChanged =
      trackerRenderedStage !== stage;

    trackerRenderedStage =
      stage;

    if (stageChanged) {
      const currentStep =
        trackerSteps[currentIndex];

      window.requestAnimationFrame(
        () => {
          centerTrackerStep(
            currentStep
          );
        }
      );
    }
  }

  function playTrackerEntrance() {
    if (
      trackerHasAnimated ||
      !tracker
    ) {
      return;
    }

    trackerHasAnimated = true;

    if (reducedMotionMedia.matches) {
      return;
    }

    tracker.classList.remove(
      'is-entering'
    );

    void tracker.offsetWidth;

    tracker.classList.add(
      'is-entering'
    );

    window.setTimeout(
      () => {
        tracker.classList.remove(
          'is-entering'
        );
      },
      1600
    );
  }

  function pulseCurrentTrackerIcon() {
    if (
      reducedMotionMedia.matches ||
      document.hidden
    ) {
      return;
    }

    const targets = [];

    if (trackerIsVisible) {
      targets.push(tracker);
    }

    if (
      floatingTracker?.classList.contains(
        'is-visible'
      )
    ) {
      targets.push(
        floatingTracker
      );
    }

    targets.forEach(
      (target) => {
        target.classList.remove(
          'is-pulsing'
        );

        void target.offsetWidth;

        target.classList.add(
          'is-pulsing'
        );

        window.setTimeout(
          () => {
            target.classList.remove(
              'is-pulsing'
            );
          },
          1100
        );
      }
    );
  }

  function getTrackerHeaderBottom() {
    const headerCandidates =
      Array.from(
        document.querySelectorAll(
          [
            '#shopify-section-header',
            '.shopify-section-group-header-group',
            'sticky-header',
            '.header-wrapper',
          ].join(',')
        )
      );

    return headerCandidates.reduce(
      (largestBottom, candidate) => {
        const rect =
          candidate.getBoundingClientRect();

        if (
          rect.bottom <= 0 ||
          rect.top >= window.innerHeight
        ) {
          return largestBottom;
        }

        return Math.max(
          largestBottom,
          rect.bottom
        );
      },
      0
    );
  }

  function updateFloatingTracker() {
    if (
      !tracker ||
      !floatingTracker
    ) {
      return;
    }

    const headerBottom =
      getTrackerHeaderBottom();

    floatingTracker.style.setProperty(
      '--cs-porch-float-top',
      `${Math.round(headerBottom + 6)}px`
    );

    const trackerRect =
      tracker.getBoundingClientRect();

    const shouldShow =
      trackerMobileMedia.matches &&
      trackerRect.bottom <=
        headerBottom + 2 &&
      window.scrollY > 0;

    floatingTracker.classList.toggle(
      'is-visible',
      shouldShow
    );
  }

  function scheduleFloatingTrackerUpdate() {
    if (trackerPositionFrame) {
      return;
    }

    trackerPositionFrame =
      window.requestAnimationFrame(
        () => {
          trackerPositionFrame = null;
          updateFloatingTracker();
        }
      );
  }

  function syncTrackerPlacement() {
    if (
      !tracker ||
      !trackerHome ||
      !hero ||
      !statusCard
    ) {
      return;
    }

    if (trackerMobileMedia.matches) {
      if (
        tracker.parentElement !== hero
      ) {
        statusCard.before(
          tracker
        );
      }

      tracker.classList.add(
        'is-embedded'
      );
    } else {
      if (
        tracker.parentElement === hero
      ) {
        trackerHome.after(
          tracker
        );
      }

      tracker.classList.remove(
        'is-embedded'
      );

      floatingTracker?.classList.remove(
        'is-visible'
      );
    }

    window.requestAnimationFrame(
      () => {
        const currentStep =
          tracker.querySelector(
            '[data-cs-porch-tracker-step].is-current'
          );

        centerTrackerStep(
          currentStep
        );

        updateFloatingTracker();
      }
    );
  }

  function initializeTrackerBehavior() {
    if (!tracker) return;

    syncTrackerPlacement();

    if (
      'IntersectionObserver' in window
    ) {
      const trackerObserver =
        new IntersectionObserver(
          (entries) => {
            const entry =
              entries[0];

            trackerIsVisible =
              Boolean(
                entry?.isIntersecting &&
                entry.intersectionRatio >=
                  0.2
              );

            if (
              trackerIsVisible &&
              !trackerHasAnimated
            ) {
              playTrackerEntrance();
            }

            scheduleFloatingTrackerUpdate();
          },
          {
            threshold: [
              0,
              0.2,
              0.5,
            ],
            rootMargin:
              '0px 0px -8% 0px',
          }
        );

      trackerObserver.observe(
        tracker
      );
    } else {
      trackerIsVisible = true;
      playTrackerEntrance();
    }

    window.addEventListener(
      'scroll',
      scheduleFloatingTrackerUpdate,
      {
        passive: true,
      }
    );

    window.addEventListener(
      'resize',
      () => {
        syncTrackerPlacement();
        scheduleFloatingTrackerUpdate();
      },
      {
        passive: true,
      }
    );

    trackerMobileMedia.addEventListener?.(
      'change',
      syncTrackerPlacement
    );

    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden) {
          scheduleFloatingTrackerUpdate();
        }
      }
    );

    trackerPulseTimer =
      window.setInterval(
        pulseCurrentTrackerIcon,
        8000
      );

    scheduleFloatingTrackerUpdate();
  }

  function renderState() {
    const content = getStateContent(currentState);

    statusCard.dataset.state = content.tone;
    statusLabel.textContent = content.label;
    statusTitle.textContent = content.title;
    statusCopy.textContent = content.copy;

    menuKicker.textContent = 'This week';
    menuTitle.textContent = content.menuTitle;
    menuCopy.textContent = content.menuCopy;

    // Routine states are communicated by the status card.
    // The notice remains available for genuine runtime errors.
    notice.dataset.tone = '';
    notice.innerHTML = '';

    const menuReady = isMenuReady();
    const terminalState =
      ['ended', 'cancelled'].includes(currentState);

    // Menu readiness controls menu availability, but it must not
    // overwrite the actual Porch Shop calendar state.
    if (
      !menuReady &&
      currentState === 'preview'
    ) {
      const weekday =
        currentSchedule?.now?.getUTCDay?.() ??
        getZonedNow().getUTCDay();

      statusCard.dataset.state = 'closed';

      if (
        weekday === 1 ||
        weekday === 2
      ) {
        statusLabel.textContent = 'Planning this week';
        statusTitle.textContent = 'Menu coming soon';
        statusCopy.textContent =
          'We’re putting together this week’s lineup.';
      } else {
        statusLabel.textContent = 'Next shop';
        statusTitle.textContent = content.title;
        statusCopy.textContent = 'Menu coming soon.';
      }
    }

    const menuSection =
      root.querySelector('.cs-porch__menu');

    const menuLink =
      root.querySelector('[data-cs-porch-menu-link]');

    const emptyState =
      root.querySelector('.cs-porch__empty');

    if (menuSection) {
      menuSection.hidden =
        terminalState ||
        !menuReady;
    }

    if (menuLink) {
      menuLink.hidden =
        terminalState ||
        !menuReady;
    }

    if (productList) {
      productList.hidden =
        !menuReady ||
        ['closed', 'ended', 'cancelled'].includes(
          currentState
        );
    }

    if (emptyState) {
      emptyState.hidden =
        menuReady ||
        terminalState;
    }

    if (
      !menuReady &&
      !terminalState
    ) {
      menuTitle.textContent =
        'This week’s menu';

      menuCopy.textContent =
        emptyState
          ? ''
          : 'Coming soon.';
    }

    countdown.hidden = !content.target;

    statusCard.dataset.countdownTarget =
      content.target
        ? String(content.target.getTime())
        : '';

    selectedMethod = 'pickup';

    if (methodPicker) {
      methodPicker.hidden = true;
    }

    const shouldShowAccessPanel =
      isLiveState() &&
      !liveAccessGranted;

    accessPanel.hidden =
      !shouldShowAccessPanel;

    methodButtons.forEach((button) => {
      const isSelected =
        button.dataset.csPorchMethod ===
        selectedMethod;

      button.classList.toggle(
        'is-selected',
        isSelected
      );

      button.setAttribute(
        'aria-pressed',
        String(isSelected)
      );
    });

    renderMethodDetails();
    renderTracker();
    productCards.forEach(updateProductCard);
  }

  function updateCountdown() {
    const target = Number(statusCard.dataset.countdownTarget || 0);
    if (!target || countdown.hidden) return;

    const now = getZonedNow().getTime();
    const remaining = Math.max(0, target - now);
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    countdownParts.days.textContent = String(days).padStart(2, '0');
    countdownParts.hours.textContent = String(hours).padStart(2, '0');
    countdownParts.minutes.textContent = String(minutes).padStart(2, '0');
    countdownParts.seconds.textContent = String(seconds).padStart(2, '0');
  }

  function getVariantControl(card) {
    return card.querySelector('[data-cs-porch-variant]');
  }

  function getVariantMeta(card) {
    const control = getVariantControl(card);
    const source = control?.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
    return {
      id: Number(source?.value || 0),
      gid: String(source?.dataset.gid || ''),
      price: Number(source?.dataset.price || 0),
      fallbackAvailable: source?.dataset.available === 'true',
    };
  }

  function isInventoryPreviewBypassEnabled() {
    const previewParams =
      new URLSearchParams(
        window.location.search
      );

    const themeRole =
      String(
        window.Shopify?.theme?.role ||
        ''
      ).toLowerCase();

    const isThemePreview = Boolean(
      window.Shopify?.designMode ||
      themeRole === 'unpublished' ||
      themeRole === 'development' ||
      [
        '127.0.0.1',
        'localhost',
      ].includes(
        window.location.hostname
      )
    );

    return (
      isThemePreview &&
      previewParams.get(
        'preview_inventory'
      ) === '1'
    );
  }

  function getInventory(gid, fallbackAvailable) {
    if (isInventoryPreviewBypassEnabled()) {
      return {
        quantity: undefined,
        available: true,
        exact: false,
        preview: true,
      };
    }

    if (inventoryByGid.has(gid)) {
      return inventoryByGid.get(gid);
    }

    if (!config.storefrontToken) {
      return {
        quantity: undefined,
        available: fallbackAvailable,
        exact: false,
      };
    }

    return {
      quantity: undefined,
      available: false,
      exact: false,
    };
  }

  function productActionState(meta, inventory) {
    if (!isMenuReady()) {
      return {
        disabled: true,
        label: 'Menu coming soon',
      };
    }

    if (currentState === 'cancelled') {
      return {
        disabled: true,
        label: 'Unavailable this week',
      };
    }

    if (currentState === 'ended') {
      return {
        disabled: true,
        label: 'Porch Shop closed',
      };
    }

    if (currentState === 'closed') {
      return {
        disabled: true,
        label: 'Menu coming soon',
      };
    }

    if (currentState === 'preview') {
      return {
        disabled: true,
        label: 'Available Thursday',
      };
    }

    if (currentState === 'countdown') {
      return {
        disabled: true,
        label: `Opens at ${formatClock(currentSchedule.times.liveOpen)}`,
      };
    }

    if (
      isLiveState() &&
      !liveAccessGranted
    ) {
      return {
        disabled: true,
        label: 'Enter porch code to shop',
      };
    }

    if (
      !config.storefrontToken &&
      !isInventoryPreviewBypassEnabled()
    ) {
      return {
        disabled: true,
        label: 'Inventory connection required',
      };
    }

    if (!inventory.available) {
      return {
        disabled: true,
        label: 'Sold out',
      };
    }

    if (
      inventory.exact &&
      Number(
        inventory.quantity ||
        0
      ) <= 0
    ) {
      return {
        disabled: true,
        label: 'Sold out',
      };
    }

    return {
      disabled: false,
      label: 'Add to cart',
    };
  }

  function updateProductCard(card) {
    const meta = getVariantMeta(card);
    const inventory = getInventory(meta.gid, meta.fallbackAvailable);
    const badge = card.querySelector('[data-cs-porch-inventory]');
    const button = card.querySelector('[data-cs-porch-add]');
    const label = card.querySelector('[data-cs-porch-add-label]');
    const price = card.querySelector('[data-cs-porch-price]');
    const quantityInput = card.querySelector('[data-cs-porch-quantity]');
    const quantityControl = card.querySelector('.cs-porch-product__quantity');
    const action = productActionState(meta, inventory);

    // Barry feedback: only show quantity controls during unlocked live shopping.
    const canAdjustQuantity =
      isLiveState() &&
      liveAccessGranted &&
      !action.disabled &&
      !inventoryLoading;

    if (quantityControl) {
      quantityControl.hidden =
        !canAdjustQuantity;
    }

    if (price) price.textContent = formatMoney(meta.price);
    if (button) button.disabled = action.disabled || inventoryLoading;
    if (label) label.textContent = inventoryLoading ? 'Checking inventory' : action.label;

    const exactQuantity = Number(inventory.quantity);
    const hasExactQuantity = Number.isFinite(exactQuantity);
    const soldOut = hasExactQuantity ? exactQuantity <= 0 : !inventory.available;
    card.classList.toggle('is-sold-out', soldOut || currentState === 'ended');

    if (quantityInput) {
      quantityInput.disabled = action.disabled;
      if (hasExactQuantity && exactQuantity > 0) {
        quantityInput.max = String(exactQuantity);
        quantityInput.value = String(Math.min(Math.max(1, Number(quantityInput.value) || 1), exactQuantity));
      } else {
        quantityInput.removeAttribute('max');
      }
    }

    if (
      activeProductDialogCard === card
    ) {
      syncProductDialogPurchase(
        card
      );
    }

    if (!badge) return;

    // Barry feedback: inventory messaging is only useful while the porch is live.
    if (!isLiveState()) {
      badge.hidden = true;
      return;
    }

    badge.hidden = false;

    if (currentState === 'ended' || soldOut) {
      badge.textContent = 'Sold out';
      badge.dataset.tone = 'out';
    } else if (hasExactQuantity && exactQuantity <= Number(config.lowStockThreshold || 1)) {
      badge.textContent = exactQuantity === 1 ? 'Only 1 left' : `${exactQuantity} left`;
      badge.dataset.tone = 'low';
    } else if (hasExactQuantity) {
      badge.textContent = `${exactQuantity} available`;
      badge.dataset.tone = '';
    } else if (isInventoryPreviewBypassEnabled()) {
      badge.textContent = 'Preview inventory';
      badge.dataset.tone = '';
    } else if (!config.storefrontToken) {
      badge.textContent = 'Inventory preview';
      badge.dataset.tone = 'low';
    } else {
      badge.textContent = 'Checking inventory';
      badge.dataset.tone = '';
    }
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: 'USD',
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  async function fetchInventory() {
    const token = String(config.storefrontToken || '').trim();
    if (!token || !productCards.length || inventoryLoading) {
      productCards.forEach(updateProductCard);
      return;
    }

    const gids = Array.from(new Set(productCards.flatMap((card) => {
      const control = getVariantControl(card);
      if (!control) return [];
      if (control.tagName === 'SELECT') {
        return Array.from(control.options).map((option) => option.dataset.gid).filter(Boolean);
      }
      return [control.dataset.gid].filter(Boolean);
    })));

    if (!gids.length) return;
    inventoryLoading = true;
    productCards.forEach(updateProductCard);

    const query = `query PorchInventory($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          availableForSale
          storeAvailability(first: 50) {
            nodes {
              available
              quantityAvailable
              location { name }
            }
          }
        }
      }
    }`;

    try {
      const response = await fetch(
        `https://${config.shopDomain}/api/${config.storefrontApiVersion || '2026-07'}/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
          },
          body: JSON.stringify({ query, variables: { ids: gids } }),
        }
      );

      const payload = await response.json();
      if (!response.ok || payload.errors) {
        throw new Error(payload.errors?.[0]?.message || 'Porch inventory could not be loaded.');
      }

      const next = new Map();
      (payload.data?.nodes || []).forEach((variant) => {
        if (!variant?.id) return;
        const store = (variant.storeAvailability?.nodes || []).find(
          (item) => String(item.location?.name || '').trim().toLowerCase() ===
            String(config.porchLocationName || '').trim().toLowerCase()
        );

        next.set(variant.id, {
          quantity: store ? Number(store.quantityAvailable || 0) : 0,
          available: Boolean(store?.available && Number(store.quantityAvailable || 0) > 0),
          exact: true,
        });
      });

      inventoryByGid = next;
    } catch (error) {
      console.error('Cold Sugar porch inventory error:', error);
      notice.dataset.tone = 'warning';
      notice.innerHTML = `<strong>Inventory connection:</strong> ${escapeHTML(error.message || 'Live inventory is temporarily unavailable.')}`;
    } finally {
      inventoryLoading = false;
      productCards.forEach(updateProductCard);
    }
  }

  function normalizeQuantity(card) {
    const input = card.querySelector('[data-cs-porch-quantity]');
    const meta = getVariantMeta(card);
    const inventory = getInventory(meta.gid, meta.fallbackAvailable);
    const max = Number(inventory.quantity);
    let value = Math.max(1, Number(input?.value) || 1);
    if (Number.isFinite(max) && max > 0) value = Math.min(value, max);
    if (input) input.value = String(value);
    return value;
  }

  async function fetchCart() {
    const response = await fetch(route('cart.js'), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error('Your cart could not be read. Please try again.');
    return response.json();
  }

  function isLockItem(item) {
    const value = item?.properties?._cold_sugar_pickup_lock;
    return value === true || value === 'true' || item?.handle === 'pickup-location';
  }

  function cartShoppingPath(cart) {
    const attrPath = String(cart?.attributes?.['Shopping Path'] || '').trim().toLowerCase();
    if (attrPath) return attrPath;
    const line = (cart?.items || []).find((item) => !isLockItem(item));
    return String(line?.properties?._cold_sugar_shopping_path || '').trim().toLowerCase();
  }

  function cartHasVisibleItems(cart) {
    return (cart?.items || []).some((item) => !isLockItem(item) && Number(item.quantity || 0) > 0);
  }


  function getVisibleCartItems(cart) {
    return (cart?.items || []).filter(
      (item) =>
        !isLockItem(item) &&
        Number(item.quantity || 0) > 0
    );
  }

  function getCartQuantityForVariant(cart, variantId) {
    return getVisibleCartItems(cart)
      .filter(
        (item) =>
          String(item.variant_id || item.id || '') ===
          String(variantId)
      )
      .reduce(
        (total, item) =>
          total + Number(item.quantity || 0),
        0
      );
  }

  function assertRequestedItemAvailable(
    pending,
    cart
  ) {
    const inventory =
      getInventory(
        pending.meta.gid,
        pending.meta.fallbackAvailable
      );

    const action =
      productActionState(
        pending.meta,
        inventory
      );

    if (action.disabled) {
      throw new Error(
        action.label === 'Sold out'
          ? 'This item is sold out and your cart was not changed.'
          : `${action.label}. Your cart was not changed.`
      );
    }

    if (!inventory.exact) {
      return;
    }

    const available =
      Math.max(
        0,
        Number(
          inventory.quantity ||
          0
        )
      );

    const alreadyInCart =
      getCartQuantityForVariant(
        cart,
        pending.meta.id
      );

    if (
      alreadyInCart +
        pending.quantity >
      available
    ) {
      throw new Error(
        available <= alreadyInCart
          ? 'This item is sold out in the Porch Shop and your cart was not changed.'
          : `Only ${available} total are available in the Porch Shop. Your cart was not changed.`
      );
    }
  }

  function blankFulfillmentAttributes() {
    const blank = {};

    STALE_ATTRIBUTES.forEach((key) => {
      blank[key] = '';
    });

    return blank;
  }

  async function applyCartUpdates(updates) {
    if (!Object.keys(updates).length) return;

    const response = await fetch(
      route('cart/update.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates }),
      }
    );

    const payload =
      await response.json().catch(() => ({}));

    if (!response.ok || payload.errors) {
      throw new Error(
        payload.description ||
        payload.message ||
        'The unavailable cart items could not be updated.'
      );
    }
  }

  async function addPorchPickupLock() {
    const variantId = Number(
      config.porch?.lockVariantId
    );

    if (!Number.isFinite(variantId)) {
      throw new Error(
        'The Porch Pickup lock variant is not connected yet.'
      );
    }

    const response = await fetch(
      route('cart/add.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _cold_sugar_pickup_lock: 'true',
                _cold_sugar_fulfillment_option:
                  config.porch?.handle || '',
              },
            },
          ],
        }),
      }
    );

    const payload =
      await response.json().catch(() => ({}));

    if (!response.ok || payload.status) {
      throw new Error(
        payload.description ||
        payload.message ||
        'The Porch Pickup location could not be selected.'
      );
    }
  }

  async function syncThursdayPickupLock(
    cart,
    method
  ) {
    const lockItems = (cart?.items || []).filter(
      isLockItem
    );

    if (
      method === 'delivery' &&
      !isLiveState()
    ) {
      const removals = {};

      lockItems.forEach((item) => {
        if (item.key) removals[item.key] = 0;
      });

      await applyCartUpdates(removals);
      return;
    }

    const targetVariantId = String(
      config.porch?.lockVariantId || ''
    );

    const targetHandle = String(
      config.porch?.handle || ''
    );

    if (!targetVariantId) {
      throw new Error(
        'The Porch Pickup lock variant is not connected yet.'
      );
    }

    const exactLock = lockItems.find(
      (item) =>
        String(
          item.variant_id || item.id || ''
        ) === targetVariantId &&
        String(
          item.properties?._cold_sugar_fulfillment_option ||
            ''
        ) === targetHandle
    );

    if (exactLock) {
      const extras = {};

      lockItems.forEach((item) => {
        if (
          item.key &&
          item.key !== exactLock.key
        ) {
          extras[item.key] = 0;
        }
      });

      await applyCartUpdates(extras);
      return;
    }

    await addPorchPickupLock();

    const refreshedCart = await fetchCart();
    const refreshedLocks = (
      refreshedCart.items || []
    ).filter(isLockItem);

    const newExactLock = refreshedLocks.find(
      (item) =>
        String(
          item.variant_id || item.id || ''
        ) === targetVariantId &&
        String(
          item.properties?._cold_sugar_fulfillment_option ||
            ''
        ) === targetHandle
    );

    if (!newExactLock) {
      throw new Error(
        'The Porch Pickup location could not be confirmed.'
      );
    }

    const oldLocks = {};

    refreshedLocks.forEach((item) => {
      if (
        item.key &&
        item.key !== newExactLock.key
      ) {
        oldLocks[item.key] = 0;
      }
    });

    await applyCartUpdates(oldLocks);
  }

  async function saveThursdayContext(method) {
    const path =
      getShoppingPathForMethod(method);

    const option =
      getOptionForMethod(method);

    try {
      sessionStorage.setItem(
        'coldSugarShoppingContext',
        JSON.stringify({
          shoppingPath: path,
          fulfillmentHandle:
            option?.handle || '',
          eventDate:
            currentSchedule.iso,
          savedAt: Date.now(),
        })
      );
    } catch (error) {
      // Session storage is optional.
    }
  }

  async function syncCartToThursday(
    cart,
    method
  ) {
    const response = await fetch(
      route('cart/update.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          attributes:
            buildCartAttributes(method),
        }),
      }
    );

    const payload =
      await response.json().catch(() => ({}));

    if (
      !response.ok ||
      payload.status ||
      payload.errors
    ) {
      throw new Error(
        payload.description ||
        payload.message ||
        'The Thursday fulfillment details could not be saved.'
      );
    }

    await syncThursdayPickupLock(
      cart,
      method
    );

    await saveThursdayContext(method);
  }

  async function addRequestedProduct(
    pending,
    method
  ) {
    const path =
      getShoppingPathForMethod(method);

    const response = await fetch(
      route('cart/add.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id: pending.meta.id,
              quantity: pending.quantity,
              properties: {
                _cold_sugar_order_mode: 'local',
                _cold_sugar_shopping_path:
                  path,
                _cold_sugar_porch_event:
                  currentSchedule.iso,
              },
            },
          ],
        }),
      }
    );

    const payload = await response.json();

    if (!response.ok || payload.status) {
      throw new Error(
        payload.description ||
        payload.message ||
        'This item could not be added.'
      );
    }
  }

  async function migrateAndAdd({
    pending,
    method,
  }) {
    let cart =
      await fetchCart();

    assertRequestedItemAvailable(
      pending,
      cart
    );

    await addRequestedProduct(
      pending,
      method
    );

    cart =
      await fetchCart();

    await syncCartToThursday(
      cart,
      method
    );

    const updatedCart =
      await fetchCart();

    await refreshCartUi(
      updatedCart
    );

    await fetchInventory();

    const message =
      pending.card.querySelector(
        '[data-cs-porch-product-message]'
      );

    if (message) {
      message.textContent =
        'Added to cart.';
    }
  }

  function configureMigrationDialog() {
    if (switchDialogKicker) {
      switchDialogKicker.textContent =
        'Start a live Porch Shop purchase';
    }

    if (switchDialogTitle) {
      switchDialogTitle.textContent =
        'The Porch Shop needs a separate cart.';
    }

    if (switchDialogMessage) {
      switchDialogMessage.textContent =
        'Live Porch Shop purchases cannot be combined with order-ahead, market, or shipping orders.';
    }

    if (switchDialogItems) {
      switchDialogItems.replaceChildren();
      switchDialogItems.hidden = true;
    }

    if (switchDialogKeep) {
      switchDialogKeep.textContent =
        'Keep current cart';
    }

    if (switchDialogSwitch) {
      switchDialogSwitch.textContent =
        'Clear cart & start Porch Shop purchase';
    }
  }

  async function handleProductSubmit(card) {
    const message = card.querySelector(
      '[data-cs-porch-product-message]'
    );

    const button = card.querySelector(
      '[data-cs-porch-add]'
    );

    const meta = getVariantMeta(card);
    const quantity = normalizeQuantity(card);

    const pending = {
      card,
      meta,
      quantity,
    };

    if (message) {
      message.textContent = '';
    }

    try {
      const preliminaryInventory =
        getInventory(
          meta.gid,
          meta.fallbackAvailable
        );

      const preliminaryAction =
        productActionState(
          meta,
          preliminaryInventory
        );

      if (
        button?.disabled ||
        preliminaryAction.disabled
      ) {
        throw new Error(
          preliminaryAction.label === 'Sold out'
            ? 'This item is sold out and your cart was not changed.'
            : `${preliminaryAction.label}. Your cart was not changed.`
        );
      }

      if (
        !window.ColdSugarOrderMode ||
        typeof window.ColdSugarOrderMode.beforeAnyAdd !== 'function'
      ) {
        throw new Error(
          'Cart protection is still loading. Please wait a moment and try again.'
        );
      }

      const mayContinue =
        await window.ColdSugarOrderMode.beforeAnyAdd({
          trigger: button,
        });

      if (!mayContinue) {
        return;
      }

      button.disabled = true;

      const cart = await fetchCart();

      assertRequestedItemAvailable(
        pending,
        cart
      );

      const visibleItems =
        getVisibleCartItems(cart);

      const existingPath =
        cartShoppingPath(cart);

      const targetPath =
        'porch_live';

      const requiresFreshCart =
        visibleItems.length > 0 &&
        existingPath !== targetPath;

      if (requiresFreshCart) {
        pendingAdd = pending;

        pendingMigration = {
          mode: 'clear',
          method: selectedMethod,
        };

        configureMigrationDialog();
        openSwitchDialog();
        return;
      }

      await migrateAndAdd({
        pending,
        method: selectedMethod,
      });
    } catch (error) {
      if (message) {
        message.textContent =
          error.message ||
          'This item could not be added.';
      }
    } finally {
      updateProductCard(card);
    }
  }

  function buildCartAttributes() {
    const eventDate =
      currentSchedule.eventDate;

    const dateLabel =
      formatDate(
        eventDate,
        true
      );

    const dayLabel =
      formatDay(eventDate);

    const windowLabel =
      config.porch?.timeWindow ||
      config.porch?.displaySchedule ||
      '3–7 PM';

    const blank = {};

    STALE_ATTRIBUTES.forEach(
      (key) => {
        blank[key] = '';
      }
    );

    return {
      ...blank,
      'Shopping Path':
        'porch_live',
      'Porch Live Purchase':
        'Yes',
      'Thursday Live Open Time':
        currentSchedule.times.liveOpen,
      'Thursday Live Close Time':
        currentSchedule.times.liveClose,
      'Fulfillment Category':
        'pickup',
      'Fulfillment Type':
        'Live Porch Shop',
      'Fulfillment Option Handle':
        config.porch?.handle ||
        '',
      'Fulfillment Option Name':
        config.porch?.displayName ||
        'Parmer Ranch Porch Shop',
      'Pickup Event ID':
        `pickup-${
          config.porch?.handle ||
          'porch'
        }-${currentSchedule.iso}`,
      'Pickup Date':
        dateLabel,
      'Pickup Day':
        dayLabel,
      'Pickup Location':
        config.porch?.displayName ||
        'Parmer Ranch Porch Shop',
      'Pickup City State':
        config.porch?.cityState ||
        '',
      'Pickup Address':
        config.porch?.fullAddress ||
        '',
      'Pickup Window':
        windowLabel,
      'Pickup Instructions':
        'Live self-serve Porch Shop purchase. Complete checkout before taking only the products purchased.',
      'Checkout Method To Select':
        config.porch?.checkoutInstruction ||
        'Complete checkout on your phone before taking any items from the porch.',
    };
  }

  async function confirmThursdayMigration() {
    if (!pendingMigration || !pendingAdd) {
      return;
    }

    const migration = pendingMigration;
    const pending = pendingAdd;

    if (switchDialogSwitch) {
      switchDialogSwitch.disabled = true;
      switchDialogSwitch.textContent =
        'Starting Porch Shop purchase…';
    }

    if (switchDialogKeep) {
      switchDialogKeep.disabled = true;
    }

    if (switchDialogClose) {
      switchDialogClose.disabled = true;
    }

    try {
      if (migration.mode === 'clear') {
        const clearResponse = await fetch(
          route('cart/clear.js'),
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({}),
          }
        );

        if (!clearResponse.ok) {
          throw new Error(
            'The current cart could not be cleared.'
          );
        }

        await fetch(
          route('cart/update.js'),
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes:
                blankFulfillmentAttributes(),
            }),
          }
        );
      }

      await migrateAndAdd({
        pending,
        method: migration.method,
      });

      pendingAdd = null;
      pendingMigration = null;
      closeSwitchDialog();
    } catch (error) {
      const errorMessage =
        error.message ||
        'The cart could not be switched.';

      const message =
        pending.card.querySelector(
          '[data-cs-porch-product-message]'
        );

      if (message) {
        message.textContent =
          errorMessage;
      }

      if (switchDialogKicker) {
        switchDialogKicker.textContent =
          'We could not finish the update';
      }

      if (switchDialogTitle) {
        switchDialogTitle.textContent =
          'Your cart needs another try.';
      }

      if (switchDialogMessage) {
        switchDialogMessage.textContent =
          `${errorMessage} Your existing products were kept whenever possible.`;
      }

      console.error(
        'Thursday cart migration failed:',
        error
      );
    } finally {
      if (switchDialogSwitch) {
        switchDialogSwitch.disabled = false;
        switchDialogSwitch.textContent =
          migration.mode === 'clear'
            ? 'Try again'
            : 'Try update again';
      }

      if (switchDialogKeep) {
        switchDialogKeep.disabled = false;
      }

      if (switchDialogClose) {
        switchDialogClose.disabled = false;
      }
    }
  }

  function openSwitchDialog() {
    if (!switchDialog) return;
    if (typeof switchDialog.showModal === 'function') switchDialog.showModal();
    else switchDialog.setAttribute('open', '');
  }

  function closeSwitchDialog() {
    if (!switchDialog) return;
    if (typeof switchDialog.close === 'function' && switchDialog.open) switchDialog.close();
    else switchDialog.removeAttribute('open');
  }

  async function refreshCartUi(cart) {
    const notification =
      document.querySelector('cart-notification');

    if (notification) {
      try {
        if (
          typeof notification.refreshCartBubble ===
          'function'
        ) {
          await notification.refreshCartBubble();
        } else {
          updateVisibleCartCount(cart);
        }

        if (
          typeof notification.refreshFromCart ===
          'function'
        ) {
          await notification.refreshFromCart(cart);
        } else if (
          typeof notification.renderFullCart ===
            'function' &&
          typeof notification.open === 'function'
        ) {
          notification.renderFullCart(cart);
          notification.open();
        } else {
          throw new Error(
            'The cart notification could not be refreshed.'
          );
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart },
          })
        );
        return;
      } catch (error) {
        console.error(
          'Porch cart notification refresh failed:',
          error
        );
        window.location.assign(route('cart'));
        return;
      }
    }

    updateVisibleCartCount(cart);
    const drawer =
      document.querySelector('cart-drawer');

    if (!drawer) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart },
        })
      );
      return;
    }

    try {
      const response = await fetch(
        route('cart?section_id=cart-drawer'),
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        }
      );
      const text = await response.text();
      const doc = new DOMParser().parseFromString(
        text,
        'text/html'
      );
      const source =
        doc.querySelector('cart-drawer');

      if (!source) {
        throw new Error(
          'Refreshed cart drawer was not found.'
        );
      }

      drawer.innerHTML = source.innerHTML;
      drawer.className = source.className;

      const overlay =
        drawer.querySelector('#CartDrawer-Overlay');

      if (
        overlay &&
        typeof drawer.close === 'function'
      ) {
        overlay.addEventListener(
          'click',
          drawer.close.bind(drawer)
        );
      }

      const summary = drawer.querySelector(
        '[id^="Details-"] summary'
      );

      if (
        summary &&
        typeof drawer.setSummaryAccessibility ===
          'function'
      ) {
        drawer.setSummaryAccessibility(summary);
      }

      if (typeof drawer.open === 'function') {
        drawer.open();
      }
    } catch (error) {
      console.error(
        'Porch cart drawer refresh failed:',
        error
      );
      window.location.assign(route('cart'));
    }
  }

  function updateVisibleCartCount(cart) {
    const count = (cart.items || []).reduce((total, item) => isLockItem(item)
      ? total
      : total + Number(item.quantity || 0), 0);
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((node) => {
      node.textContent = String(count);
    });
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.classList.toggle('hidden', count === 0);
    });
  }

  function route(path) {
    const base = window.Shopify?.routes?.root || '/';
    return `${base.replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
  }

  function syncProductDialogPurchase(
    card
  ) {
    if (
      !card ||
      card !== activeProductDialogCard ||
      !productDialogContent
    ) {
      return;
    }

    const originalQuantity =
      card.querySelector(
        '[data-cs-porch-quantity]'
      );

    const originalAdd =
      card.querySelector(
        '[data-cs-porch-add]'
      );

    const originalAddLabel =
      card.querySelector(
        '[data-cs-porch-add-label]'
      );

    const originalPrice =
      card.querySelector(
        '[data-cs-porch-price]'
      );

    const originalMessage =
      card.querySelector(
        '[data-cs-porch-product-message]'
      );

    const originalVariant =
      getVariantControl(card);

    const modalQuantity =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-quantity]'
      );

    const modalMinus =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-quantity-minus]'
      );

    const modalPlus =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-quantity-plus]'
      );

    const modalAdd =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-add]'
      );

    const modalAddLabel =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-add-label]'
      );

    const modalPrice =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-price]'
      );

    const modalMessage =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-message]'
      );

    const modalVariant =
      productDialogContent.querySelector(
        '[data-cs-porch-dialog-variant]'
      );

    if (
      modalQuantity &&
      originalQuantity
    ) {
      modalQuantity.value =
        originalQuantity.value || '1';

      modalQuantity.disabled =
        originalQuantity.disabled;

      if (
        originalQuantity.hasAttribute(
          'max'
        )
      ) {
        modalQuantity.max =
          originalQuantity.max;
      } else {
        modalQuantity.removeAttribute(
          'max'
        );
      }
    }

    if (modalMinus) {
      modalMinus.disabled =
        Boolean(
          originalQuantity?.disabled
        );
    }

    if (modalPlus) {
      modalPlus.disabled =
        Boolean(
          originalQuantity?.disabled
        );
    }

    if (modalAdd) {
      modalAdd.disabled =
        Boolean(
          originalAdd?.disabled
        );
    }

    if (modalAddLabel) {
      modalAddLabel.textContent =
        originalAddLabel?.textContent
          ?.trim() ||
        'Add to cart';
    }

    if (modalPrice) {
      modalPrice.textContent =
        originalPrice?.textContent
          ?.trim() ||
        '';
    }

    if (modalMessage) {
      modalMessage.textContent =
        originalMessage?.textContent
          ?.trim() ||
        '';
    }

    if (
      modalVariant &&
      originalVariant?.tagName ===
        'SELECT'
    ) {
      modalVariant.value =
        originalVariant.value;

      modalVariant.disabled =
        originalVariant.disabled;
    }
  }

  function buildProductDialogPurchase(
    card
  ) {
    if (
      !card ||
      !productDialogContent
    ) {
      return;
    }

    const mount =
      productDialogContent.querySelector(
        '[data-cs-porch-product-dialog-purchase]'
      );

    const originalForm =
      card.querySelector(
        '[data-cs-porch-product-form]'
      );

    const originalQuantity =
      card.querySelector(
        '[data-cs-porch-quantity]'
      );

    const originalVariant =
      getVariantControl(card);

    if (
      !mount ||
      !originalForm ||
      !originalQuantity
    ) {
      return;
    }

    mount.replaceChildren();

    if (
      originalVariant?.tagName ===
        'SELECT'
    ) {
      const variantLabel =
        document.createElement(
          'label'
        );

      const variantSelect =
        originalVariant.cloneNode(
          true
        );

      const variantId =
        `PorchDialogVariant-${Date.now()}`;

      variantLabel.htmlFor =
        variantId;

      variantLabel.textContent =
        'Choose an option';

      variantSelect.id =
        variantId;

      variantSelect.removeAttribute(
        'name'
      );

      variantSelect.dataset.csPorchDialogVariant =
        '';

      variantSelect.addEventListener(
        'change',
        () => {
          originalVariant.value =
            variantSelect.value;

          originalVariant.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true,
              }
            )
          );

          syncProductDialogPurchase(
            card
          );
        }
      );

      mount.append(
        variantLabel,
        variantSelect
      );
    }

    const purchaseRow =
      document.createElement(
        'div'
      );

    purchaseRow.className =
      'cs-porch-product-dialog__purchase-row';

    const price =
      document.createElement(
        'strong'
      );

    price.className =
      'cs-porch-product-dialog__price';

    price.dataset.csPorchDialogPrice =
      '';

    const quantity =
      document.createElement(
        'div'
      );

    quantity.className =
      'cs-porch-product-dialog__quantity';

    const minus =
      document.createElement(
        'button'
      );

    minus.type =
      'button';

    minus.setAttribute(
      'aria-label',
      'Decrease quantity'
    );

    minus.dataset.csPorchDialogQuantityMinus =
      '';

    minus.textContent =
      '−';

    const quantityInput =
      document.createElement(
        'input'
      );

    quantityInput.type =
      'number';

    quantityInput.min =
      '1';

    quantityInput.step =
      '1';

    quantityInput.inputMode =
      'numeric';

    quantityInput.setAttribute(
      'aria-label',
      'Quantity'
    );

    quantityInput.dataset.csPorchDialogQuantity =
      '';

    const plus =
      document.createElement(
        'button'
      );

    plus.type =
      'button';

    plus.setAttribute(
      'aria-label',
      'Increase quantity'
    );

    plus.dataset.csPorchDialogQuantityPlus =
      '';

    plus.textContent =
      '+';

    quantity.append(
      minus,
      quantityInput,
      plus
    );

    purchaseRow.append(
      price,
      quantity
    );

    const addButton =
      document.createElement(
        'button'
      );

    addButton.type =
      'button';

    addButton.className =
      'button button--primary cs-porch-product-dialog__add';

    addButton.dataset.csPorchDialogAdd =
      '';

    const addLabel =
      document.createElement(
        'span'
      );

    addLabel.dataset.csPorchDialogAddLabel =
      '';

    addLabel.textContent =
      'Add to cart';

    addButton.append(
      addLabel
    );

    const message =
      document.createElement(
        'p'
      );

    message.className =
      'cs-porch-product-dialog__message';

    message.dataset.csPorchDialogMessage =
      '';

    message.setAttribute(
      'role',
      'status'
    );

    minus.addEventListener(
      'click',
      () => {
        originalQuantity.value =
          String(
            Math.max(
              1,
              Number(
                originalQuantity.value ||
                1
              ) - 1
            )
          );

        normalizeQuantity(card);

        syncProductDialogPurchase(
          card
        );
      }
    );

    plus.addEventListener(
      'click',
      () => {
        originalQuantity.value =
          String(
            Number(
              originalQuantity.value ||
              1
            ) + 1
          );

        normalizeQuantity(card);

        syncProductDialogPurchase(
          card
        );
      }
    );

    const applyModalQuantity =
      () => {
        originalQuantity.value =
          quantityInput.value;

        normalizeQuantity(card);

        syncProductDialogPurchase(
          card
        );
      };

    quantityInput.addEventListener(
      'change',
      applyModalQuantity
    );

    quantityInput.addEventListener(
      'input',
      applyModalQuantity
    );

    addButton.addEventListener(
      'click',
      () => {
        originalQuantity.value =
          quantityInput.value;

        normalizeQuantity(card);

        closeProductDialog();

        window.requestAnimationFrame(
          () => {
            if (
              typeof originalForm.requestSubmit ===
                'function'
            ) {
              originalForm.requestSubmit();
            } else {
              originalForm.dispatchEvent(
                new Event(
                  'submit',
                  {
                    bubbles: true,
                    cancelable: true,
                  }
                )
              );
            }
          }
        );
      }
    );

    mount.append(
      purchaseRow,
      addButton,
      message
    );

    syncProductDialogPurchase(
      card
    );
  }

  function finishProductDialogClose() {
    document.body.classList.remove(
      'cs-porch-product-dialog-open'
    );

    productDialogObserver?.disconnect();
    productDialogObserver = null;
    activeProductDialogCard = null;

    if (productDialogContent) {
      productDialogContent.replaceChildren();
    }

    if (
      lastProductDialogTrigger &&
      document.contains(
        lastProductDialogTrigger
      )
    ) {
      lastProductDialogTrigger.focus();
    }

    lastProductDialogTrigger = null;
  }

  function closeProductDialog() {
    if (!productDialog) return;

    if (
      typeof productDialog.close ===
        'function' &&
      productDialog.open
    ) {
      productDialog.close();
      return;
    }

    productDialog.removeAttribute(
      'open'
    );

    finishProductDialogClose();
  }

  function openProductDialog(
    card,
    trigger
  ) {
    if (
      !productDialog ||
      !productDialogContent ||
      !card
    ) {
      return;
    }

    const template =
      card.querySelector(
        '[data-cs-porch-product-details]'
      );

    if (!template) return;

    lastProductDialogTrigger =
      trigger || null;

    productDialogContent.replaceChildren(
      template.content.cloneNode(true)
    );

    activeProductDialogCard =
      card;

    buildProductDialogPurchase(
      card
    );

    productDialogObserver?.disconnect();

    productDialogObserver =
      new MutationObserver(
        () => {
          syncProductDialogPurchase(
            card
          );
        }
      );

    productDialogObserver.observe(
      card,
      {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'disabled',
          'max',
        ],
      }
    );

    document.body.classList.add(
      'cs-porch-product-dialog-open'
    );

    if (
      typeof productDialog.showModal ===
      'function'
    ) {
      productDialog.showModal();
    } else {
      productDialog.setAttribute(
        'open',
        ''
      );
    }

    window.requestAnimationFrame(
      () => {
        productDialogClose?.focus();
      }
    );
  }

  function bindEvents() {
    methodButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const targetMethod =
          button.dataset.csPorchMethod === 'delivery'
            ? 'delivery'
            : 'pickup';

        if (targetMethod === selectedMethod) {
          return;
        }

        const previousMethod = selectedMethod;
        button.disabled = true;

        try {
          const cart = await fetchCart();
          const existingPath =
            cartShoppingPath(cart);

          selectedMethod = targetMethod;

          const next =
            new URL(window.location.href);

          next.searchParams.set(
            'method',
            selectedMethod
          );

          window.history.replaceState(
            {},
            '',
            next
          );

          renderState();
        } catch (error) {
          selectedMethod = previousMethod;

          if (notice) {
            notice.dataset.tone = 'warning';
            notice.innerHTML =
              `<strong>Shopping option:</strong> ${
                escapeHTML(
                  error.message ||
                  'The shopping option could not be changed.'
                )
              }`;
          }

          renderState();
        } finally {
          button.disabled = false;
        }
      });
    });

    accessInput?.addEventListener('input', () => {
      const digits =
        String(accessInput.value || '')
          .replace(/\D/g, '')
          .slice(0, 6);

      if (accessInput.value !== digits) {
        accessInput.value = digits;
      }
    });

    accessForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const expected = generateAccessCode(currentSchedule.iso);
      const entered = String(accessInput?.value || '').trim();

      if (entered === expected) {
        liveAccessGranted = true;
        saveLiveAccess();
        accessMessage.textContent = '';

        if (accessInput) {
          accessInput.value = '';
          accessInput.blur();
        }

        renderState();

        const scrollToUnlockedMenu = () => {
          const menu = root.querySelector('#ThursdayMenu');
          if (!menu) return;

          const headerOffset = 110;
          const targetTop =
            menu.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;

          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth'
          });

          history.replaceState(
            null,
            '',
            window.location.pathname +
              window.location.search +
              '#ThursdayMenu'
          );
        };

        let unlockScrollDone = false;

        const finishUnlockScroll = () => {
          if (unlockScrollDone) return;
          unlockScrollDone = true;

          window.setTimeout(scrollToUnlockedMenu, 100);
        };

        if (window.visualViewport) {
          window.visualViewport.addEventListener(
            'resize',
            finishUnlockScroll,
            { once: true }
          );

          // Fallback in case this browser does not fire a
          // visualViewport resize when the keyboard closes.
          window.setTimeout(finishUnlockScroll, 700);
        } else {
          window.setTimeout(finishUnlockScroll, 400);
        }
      } else {
        accessMessage.textContent = 'That code does not match the current porch event.';
        if (accessInput) {
          accessInput.value = '';
          accessInput.focus();
        }
      }
    });

    productDialogClose?.addEventListener(
      'click',
      closeProductDialog
    );

    productDialog?.addEventListener(
      'cancel',
      (event) => {
        event.preventDefault();
        closeProductDialog();
      }
    );

    productDialog?.addEventListener(
      'close',
      finishProductDialogClose
    );

    productDialog?.addEventListener(
      'click',
      (event) => {
        if (event.target === productDialog) {
          closeProductDialog();
        }
      }
    );

    productCards.forEach((card) => {
      card
        .querySelectorAll(
          '[data-cs-porch-product-details-open]'
        )
        .forEach(
          (trigger) => {
            trigger.addEventListener(
              'click',
              () => {
                openProductDialog(
                  card,
                  trigger
                );
              }
            );
          }
        );

      const form = card.querySelector('[data-cs-porch-product-form]');
      const variant = getVariantControl(card);
      const input = card.querySelector('[data-cs-porch-quantity]');
      card.querySelector('[data-cs-porch-quantity-minus]')?.addEventListener('click', () => {
        if (input) input.value = String(Math.max(1, Number(input.value || 1) - 1));
        normalizeQuantity(card);
      });
      card.querySelector('[data-cs-porch-quantity-plus]')?.addEventListener('click', () => {
        if (input) input.value = String(Number(input.value || 1) + 1);
        normalizeQuantity(card);
      });
      input?.addEventListener('change', () => normalizeQuantity(card));
      variant?.addEventListener('change', () => updateProductCard(card));
      form?.addEventListener('submit', (event) => {
        event.preventDefault();
        void handleProductSubmit(card);
      });
    });

    switchDialogClose?.addEventListener(
      'click',
      () => {
        pendingAdd = null;
        pendingMigration = null;
        closeSwitchDialog();
      }
    );

    switchDialogKeep?.addEventListener(
      'click',
      () => {
        pendingAdd = null;
        pendingMigration = null;
        closeSwitchDialog();
      }
    );

    switchDialogSwitch?.addEventListener(
      'click',
      () => void confirmThursdayMigration()
    );
    switchDialog?.addEventListener('click', (event) => {
      if (event.target === switchDialog) closeSwitchDialog();
    });
  }

  async function restoreSelectedMethodFromCart() {
    selectedMethod = 'pickup';
  }

  function refreshState() {
    currentSchedule = buildSchedule();
    currentState = resolveState(currentSchedule);
    syncLocalPreviewContext();
    liveAccessGranted = isLiveState() ? readLiveAccess() : false;

    const previewParams = new URLSearchParams(window.location.search);
    const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
    const isThemePreview = Boolean(
      window.Shopify?.designMode ||
      themeRole === 'unpublished' ||
      themeRole === 'development' ||
      ['127.0.0.1', 'localhost'].includes(window.location.hostname)
    );

    if (operatorPanel) {
      operatorPanel.hidden = !isThemePreview;

      if (isThemePreview && operatorCode) {
        operatorCode.textContent = generateAccessCode(currentSchedule.iso);
      }
    }

    renderState();
    updateCountdown();
  }

  function startTimers() {
    countdownTimer = window.setInterval(updateCountdown, 1000);
    stateTimer = window.setInterval(refreshState, 30000);
    const refreshMs = Math.max(15, Number(config.inventoryRefreshSeconds || 30)) * 1000;
    inventoryTimer = window.setInterval(() => void fetchInventory(), refreshMs);
  }

  async function initializePorchPage() {
    await restoreSelectedMethodFromCart();

    bindEvents();
    refreshState();
    initializeTrackerBehavior();
    void fetchInventory();
    startTimers();
  }

  void initializePorchPage();
})();


/* CS PORCH: force QR hash landing */
(() => {
  function landOnPorchCode() {
    if (window.location.hash !== '#PorchCode') return;

    const accessPanel = document.querySelector('[data-cs-porch-access]');
    const anchor = document.getElementById('PorchCode');

    const target =
      accessPanel && !accessPanel.hidden
        ? accessPanel
        : anchor;

    if (!target) return;

    const go = () => {
      const headerOffset = 110;
      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'auto'
      });
    };

    // First pass after page layout.
    requestAnimationFrame(() => {
      requestAnimationFrame(go);
    });

    // Second pass catches fonts/images/state changes.
    setTimeout(go, 500);
  }

  if (document.readyState === 'complete') {
    landOnPorchCode();
  } else {
    window.addEventListener('load', landOnPorchCode, { once: true });
  }
})();
